export default __webpack_public_path__ + "a5576d33535a69c0af5aaabfea3a902c.png";